module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "invitedperson"
  }, [_c('AppHeading', {
    attrs: {
      "level": "4",
      "mod": "bold"
    }
  }, [_vm._v(_vm._s(_vm.fio))]), _c('AppText', {
    attrs: {
      "mod": "smallest, no-bottom"
    }
  }, [_vm._v("email: "), _c('strong', [_vm._v(_vm._s(_vm.email))])]), _c('AppText', {
    attrs: {
      "mod": "smallest, no-bottom"
    }
  }, [_vm._v("cтатус: "), _c('strong', [_vm._v(_vm._s(_vm.state))])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6465574a","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/blocks/children/sidebar/components/invitedperson/InvitedPerson.vue
// module id = 53a600bbd3924d96032e
// module chunks = 89